export const CLASS_UPDATES_PANEL = 'updates-panel';
